import styled from 'styled-components'
import { colors } from 'Styled/variables'

export const TrackInfoContainer = styled.div`
  display: flex;
  align-items: center;
`

export const Avatar = styled.img`
  margin-right: 16px;
  width: 40px;
  height: 40px;
  border-radius: 4px;
`

export const TextInfo = styled.div`
  line-height: 21px;
  display: grid;
  gap: 4px;
`

export const Title = styled.span`
  color: ${colors.mainText};
  font-size: 14px;
  font-weight: 600;
  line-height: 21px;
`

export const Author = styled(Title)`
  font-weight: 400;
`
